export interface CalculateDeliveryDateResponse {
  deliveryDate: Date;
}
